import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AutomatedPlanAllTasksPage = withSuspense(
	lazy(async () => await import('./automated-plan-all-tasks-page.component')),
	PageLoader,
);
